export enum AccountTypeId {
  Account,
  Patient,
  HealthcareProfessional,
}
